import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_96: FaireProductEntity = {
  token: "starter_collection_96",
  type: "product",
  name: "Piano Cocktail Glasses - Dizzy",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    '"https://cdn.faire.com/fastly/31cd9fc1f11d25ad326d812d365a3ca846167a6a49957bc3dc54ab07521d60fa.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2064',
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
